import type { I18nTranslateOptions } from './types';

const INTERPOLATION_PATTERN = /{{\s*([A-Za-z0-9_.-]+)\s*}}/g;

export const interpolateTranslation = (template: string, options?: I18nTranslateOptions): string => {
  if (!options?.values) {
    return template;
  }

  return template.replace(INTERPOLATION_PATTERN, (fullMatch, key: string) => {
    const value = options.values?.[key];

    if (value === null || value === undefined) {
      return fullMatch;
    }

    return String(value);
  });
};
